"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getCordova() {
    return window["cordova"];
}
/**Si es necesario le pregunta al usuario por el permiso de la camara. Devuelve true si el permiso esta concedido */
async function concederPermisoCamara() {
    const cordova = getCordova();
    //Si la app no es de cordova entonces estamos en web, lo que indica que si se tiene el permis
    if (cordova == null)
        return true;
    if (cordova.plugins.permissions == null) {
        throw new Error("Instale el plugin 'cordova-plugin-android-permissions' para poder pedir el permiso de la cámara para el lector QR");
    }
    const permissions = cordova.plugins.permissions;
    const checkPermission = await new Promise(resolve => permissions.checkPermission(permissions.CAMERA, status => resolve(status.hasPermission)));
    if (checkPermission) {
        //El usuario ya otorgó el permiso anteriormente
        return true;
    }
    const requestPermission = await new Promise(resolve => permissions.requestPermission(permissions.CAMERA, status => resolve(status.hasPermission)));
    //Devolvemos si el usuario acepto o no dar el permiso
    return requestPermission;
}
exports.concederPermisoCamara = concederPermisoCamara;



//////////////////
// WEBPACK FOOTER
// ./~/kea-react/dist/qr/permisos.js
// module id = 2250
// module chunks = 0